import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import { getLocationNotes } from './api'
import { LocationNote } from './typings'
import { StoreData } from '../reducers/typings'

const locationNotesAdapter = createEntityAdapter<LocationNote>()

export const initialState = locationNotesAdapter.getInitialState()

export const locationNoteSlice = createSlice({
  name: 'locationNotes',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getLocationNotes.pending, (state) => {
      locationNotesAdapter.removeAll(state)
    })
    builder.addCase(getLocationNotes.fulfilled, (state, { payload }) => {
      locationNotesAdapter.addMany(state, payload.items || [])
    })
  },
})

export default locationNoteSlice.reducer

//#region selectors
export const locationNoteSelectors =
  locationNotesAdapter.getSelectors<StoreData>((state) => state.locationNotes)

export const { selectAll: selectAllLocationNotes } = locationNoteSelectors
//#endregion
